<template>
    <div class="panel">
        <COPDTable v-bind:tableData="meds" />
    </div>
</template>

<script>
    import COPDTable from '@/components/COPDTable.vue'

    export default {
        name: 'Meds_panel',
        mounted: function() {
            this.meds.items.forEach(function(med, i) {
                setTimeout(function() {
                    med.show = true;
                }, 250 * i);
            });
        },
        data: function() {
            return {
                meds: {
                    headers: [ 'My Medications' ],
                    items: [
                        {
                            id: 'albuterol',
                            show: false,
                            class: 'row-a',
                            cols: [ 'Albuterol (Rescue Inhaler)' ]
                        }, {
                            id: 'Spirava',
                            show: false,
                            class: 'row-b',
                            cols: [ 'Spirava (Capsule, with Inhalation Device)' ]
                        }, {
                            id: 'Prednisolone',
                            show: false,
                            class: 'row-c',
                            cols: [ 'Prednisolone (100 mg Tablet, Once a Day)' ]
                        }, {
                            id: 'Calritin',
                            show: false,
                            class: 'row-d',
                            cols: [ 'Calritin (OTC Gel Cap, as needed)' ]
                        }
                    ]
                }
            };
        },
        components: {
            COPDTable
        }
    }
</script>